var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgB2Charts2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-99debfb8-e744-40ef-b390-c34afca1028b",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 410",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "pie2-pie"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m298.92,239.11l97.97,109.56",
    style: {
      fill: "none",
      stroke: "#00b2b8",
      strokeWidth: "1.1px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m298.92,239.11l-51.96-138.98",
    style: {
      fill: "none",
      stroke: "#00b2b8",
      strokeWidth: "1.1px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m298.92,239.11l-128.96-74.5",
    style: {
      fill: "none",
      stroke: "#00b2b8",
      strokeWidth: "1.1px"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m324.42,369.87c72.54-14.76,119.39-85.53,104.63-158.08-14.76-72.54-85.53-119.39-158.08-104.63h0c-72.54,14.76-119.39,85.53-104.63,158.08,14.76,72.54,85.53,119.39,158.08,104.63",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m324.42,369.87c72.54-14.76,119.39-85.53,104.63-158.08-14.76-72.54-85.53-119.39-158.08-104.63h0c-72.54,14.76-119.39,85.53-104.63,158.08,14.76,72.54,85.53,119.39,158.08,104.63h0Z",
    style: {
      fill: "none",
      stroke: "#00b2b8",
      strokeWidth: "1.1px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m297.69,238.51l-25.3-119.05c8.32-1.76,16.8-2.66,25.3-2.66v121.71h0Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m297.69,238.51l-59-106.45c10.49-5.97,21.87-10.22,33.7-12.6l25.3,119.05h0Z",
    style: {
      fill: "#034e62",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m297.69,238.51h-121.71c0-45.57,22.84-84.35,62.7-106.45l59.01,106.45Z",
    style: {
      fill: "#00b2b8",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m297.69,238.51v-121.71c67.21,0,121.7,54.48,121.71,121.69h0c0,67.22-54.48,121.71-121.69,121.72h-.01c-67.21,0-121.7-54.48-121.71-121.69h121.71s0,0,0,0Z",
    style: {
      fill: "#ffd239",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m307.37,286.06c26.26-5.34,43.21-30.96,37.87-57.22h0c-5.34-26.26-30.96-43.21-57.22-37.87h0c-26.26,5.34-43.21,30.96-37.87,57.22s30.96,43.21,57.22,37.87h0",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m305.23,275.55c20.45-4.16,33.66-24.12,29.5-44.57h0c-4.16-20.45-24.11-33.66-44.57-29.5-20.45,4.16-33.66,24.11-29.5,44.57h0c4.16,20.45,24.11,33.66,44.57,29.5Z",
    style: {
      fill: "none",
      stroke: "#00b2b8",
      strokeWidth: "1.1px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "pie2-label1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m68.32,142.25c0,3.15-2.7,6.15-7.05,6.15-4.8,0-7.05-3.15-7.05-3.15l1.5-1.5s1.8,2.55,5.55,2.55c3.15,0,4.95-1.8,4.95-4.05,0-2.13-1.89-4.05-4.95-4.05h-2.1v-2.1h2.1c2.55,0,4.05-1.5,4.05-3.75,0-1.95-1.5-3.45-4.05-3.45-3.15,0-4.8,2.4-4.8,2.4l-1.5-1.65s2.1-2.85,6.3-2.85c3.75,0,6.3,2.55,6.3,5.55,0,3.6-3.15,4.65-3.15,4.65,0,0,3.9.9,3.9,5.25h0Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.32,148.1c0-8.85,11.25-9.15,11.25-15.15,0-2.4-1.65-4.05-4.5-4.05-3.75,0-4.5,3.6-4.5,3.6l-1.95-.9s1.05-4.8,6.45-4.8c4.05,0,6.75,2.7,6.75,6.15,0,6.45-9.15,7.5-10.95,13.05h10.95v2.1h-13.5Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.42,146.6l-3.45,5.4-1.35-.75,2.7-5.85,2.1,1.2h0Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.27,148.1c0-8.85,11.25-9.15,11.25-15.15,0-2.4-1.65-4.05-4.5-4.05-3.75,0-4.5,3.6-4.5,3.6l-1.95-.9s1.05-4.8,6.45-4.8c4.05,0,6.75,2.7,6.75,6.15,0,6.45-9.15,7.5-10.95,13.05h10.95v2.1h-13.5Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.07,127.1v2.1l-9.3,18.9h-2.25l9.3-18.9h-10.95v-2.1h13.2Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m143.31,142.1l-8.4-11.1v17.1h-2.25v-21h1.95l8.7,11.4,8.7-11.4h1.95v21h-2.25v-17.1l-8.4,11.1Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.62,139.1v1.95h-6.9c.6,2.25,3.6,5.25,7.2,5.25s5.7-2.7,5.7-2.7l1.5,1.5s-2.58,3.3-7.2,3.3-8.4-3.6-9.6-7.35h-3v-1.95h2.7v-3h-2.7v-1.95h3c1.2-3.75,4.8-7.35,9.6-7.35s7.05,3.3,7.05,3.3l-1.5,1.5s-2.01-2.7-5.55-2.7-6.6,3-7.2,5.25h6.9v1.95h-7.35v3h7.35Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m54.55,158.66h-.78v-1.03h3.43c2.58,0,4.28,1.55,4.28,4.22s-1.7,4.25-4.28,4.25h-1.88c-.54,0-.77-.23-.77-.77v-6.67Zm1.46,6.4h1.1c1.88,0,3.12-1.13,3.12-3.21s-1.25-3.19-3.12-3.19h-1.37v6.14c0,.17.1.26.26.26h.01Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.43,159.89c1.7,0,2.61,1.27,2.61,2.84,0,.16-.04.48-.04.48h-4.43c.07,1.3,1.01,2.03,2.09,2.03s1.78-.71,1.78-.71l.5.83s-.9.89-2.34.89c-1.92,0-3.23-1.38-3.23-3.18,0-1.93,1.32-3.18,3.05-3.18h.01Zm1.42,2.47c-.04-1.01-.67-1.55-1.43-1.55-.89,0-1.61.54-1.79,1.55h3.22Zm-1.04-4.73h1.18l-1.14,1.52h-.91l.88-1.52h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.6,161.29c0-.18-.1-.26-.26-.26h-.49v-1h1.09c.54,0,.74.23.74.61,0,.18-.01.32-.01.32h.02s.5-1.08,2.02-1.08c1.63,0,2.67,1.3,2.67,3.18s-1.18,3.18-2.76,3.18c-1.34,0-1.86-.97-1.86-.97h-.02s.02.22.02.53v2.7h-1.16v-7.21h0Zm2.84,3.96c.96,0,1.75-.79,1.75-2.17s-.71-2.17-1.71-2.17c-.9,0-1.75.64-1.75,2.18,0,1.08.59,2.16,1.71,2.16Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.31,159.89c1.7,0,2.61,1.27,2.61,2.84,0,.16-.04.48-.04.48h-4.43c.07,1.3,1.01,2.03,2.09,2.03s1.78-.71,1.78-.71l.5.83s-.9.89-2.34.89c-1.92,0-3.23-1.38-3.23-3.18,0-1.93,1.32-3.18,3.05-3.18h.01Zm1.42,2.47c-.04-1.01-.67-1.55-1.43-1.55-.89,0-1.61.54-1.79,1.55h3.22Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.47,161.29c0-.18-.1-.26-.26-.26h-.49v-1h1.12c.52,0,.77.23.77.67v.23c0,.19-.02.35-.02.35h.02c.24-.53.96-1.39,2.28-1.39,1.44,0,2.09.78,2.09,2.33v2.63c0,.18.1.26.26.26h.49v1h-1.15c-.54,0-.77-.23-.77-.77v-2.85c0-.85-.17-1.52-1.14-1.52s-1.68.61-1.92,1.49c-.08.24-.11.52-.11.82v2.84h-1.16v-4.83Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.89,164.4s.72.9,1.83.9c.56,0,1.06-.25,1.06-.78,0-1.09-3.31-.97-3.31-2.93,0-1.16,1.02-1.7,2.25-1.7.73,0,1.99.25,1.99,1.18v.58h-1.04v-.3c0-.36-.54-.52-.91-.52-.68,0-1.13.24-1.13.72,0,1.15,3.31.9,3.31,2.93,0,1.08-.96,1.77-2.23,1.77-1.62,0-2.42-1.07-2.42-1.07l.6-.78h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.89,159.89c1.7,0,2.61,1.27,2.61,2.84,0,.16-.04.48-.04.48h-4.43c.07,1.3,1.01,2.03,2.09,2.03s1.78-.71,1.78-.71l.5.83s-.9.89-2.34.89c-1.92,0-3.23-1.38-3.23-3.18,0-1.93,1.32-3.18,3.05-3.18h.01Zm1.42,2.47c-.04-1.01-.67-1.55-1.43-1.55-.89,0-1.61.54-1.79,1.55h3.22Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.96,164.4s.72.9,1.83.9c.56,0,1.06-.25,1.06-.78,0-1.09-3.31-.97-3.31-2.93,0-1.16,1.02-1.7,2.25-1.7.73,0,1.99.25,1.99,1.18v.58h-1.04v-.3c0-.36-.54-.52-.91-.52-.68,0-1.13.24-1.13.72,0,1.15,3.31.9,3.31,2.93,0,1.08-.96,1.77-2.23,1.77-1.62,0-2.42-1.07-2.42-1.07l.6-.78h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m113.9,159.89c1.4,0,1.87.94,1.87.94h.02s-.02-.18-.02-.41v-1.52c0-.18-.1-.26-.26-.26h-.49v-1h1.15c.54,0,.77.23.77.77v6.44c0,.18.1.26.26.26h.49v1h-1.12c-.53,0-.74-.24-.74-.65,0-.18.01-.31.01-.31h-.02s-.5,1.1-1.99,1.1c-1.64,0-2.67-1.29-2.67-3.18s1.14-3.18,2.75-3.18h-.01Zm1.91,3.17c0-1.08-.56-2.16-1.73-2.16-.95,0-1.74.79-1.74,2.17s.71,2.17,1.71,2.17c.9,0,1.75-.64,1.75-2.18h.01Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.45,159.89c1.7,0,2.61,1.27,2.61,2.84,0,.16-.04.48-.04.48h-4.43c.07,1.3,1.01,2.03,2.09,2.03s1.78-.71,1.78-.71l.5.83s-.9.89-2.34.89c-1.92,0-3.23-1.38-3.23-3.18,0-1.93,1.32-3.18,3.05-3.18h.01Zm1.42,2.47c-.04-1.01-.67-1.55-1.43-1.55-.89,0-1.61.54-1.79,1.55h3.22Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m54.34,174.97h-.76v-.94h.76v-.2c0-2,1.52-2.25,2.29-2.25.26,0,.44.04.44.04v1s-.12-.02-.3-.02c-.46,0-1.27.14-1.27,1.27v.18h1.44v.94h-1.44v5.13h-1.16v-5.15Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.65,173.89c1.81,0,3.27,1.33,3.27,3.17s-1.46,3.19-3.27,3.19-3.26-1.34-3.26-3.19,1.45-3.17,3.26-3.17Zm0,5.35c1.15,0,2.09-.91,2.09-2.18s-.94-2.16-2.09-2.16-2.07.9-2.07,2.16.94,2.18,2.07,2.18Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.38,175.29c0-.18-.1-.26-.26-.26h-.49v-1h1.12c.52,0,.77.23.77.67v.23c0,.19-.02.35-.02.35h.02c.24-.53.96-1.39,2.28-1.39,1.44,0,2.09.78,2.09,2.33v2.63c0,.18.1.26.26.26h.49v1h-1.15c-.54,0-.77-.23-.77-.77v-2.85c0-.85-.17-1.52-1.14-1.52s-1.68.61-1.92,1.49c-.08.24-.11.52-.11.82v2.84h-1.16v-4.83Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.56,173.89c.73,0,2.18.3,2.18,1.33v.62h-1.06v-.34c0-.43-.68-.62-1.13-.62-1.19,0-2.07.89-2.07,2.17,0,1.38,1.01,2.16,2.13,2.16s1.88-.84,1.88-.84l.5.83s-.86,1.04-2.47,1.04c-1.91,0-3.24-1.35-3.24-3.18s1.31-3.18,3.26-3.18h.02Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.33,174.97h-.79v-.94h.82v-1.67h1.14v1.67h1.45v.94h-1.45v2.78c0,1.21.84,1.37,1.28,1.37.17,0,.28-.02.28-.02v1.03s-.16.02-.41.02c-.77,0-2.31-.24-2.31-2.27v-2.91h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.57,175.29c0-.18-.1-.26-.26-.26h-.49v-1h1.14c.54,0,.77.23.77.77v4.04c0,.18.1.26.26.26h.49v1h-1.14c-.54,0-.77-.23-.77-.77v-4.04Zm.02-3.66h1.04v1.21h-1.04v-1.21Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.48,173.89c1.81,0,3.27,1.33,3.27,3.17s-1.46,3.19-3.27,3.19-3.26-1.34-3.26-3.19,1.45-3.17,3.26-3.17Zm0,5.35c1.15,0,2.09-.91,2.09-2.18s-.94-2.16-2.09-2.16-2.07.9-2.07,2.16.94,2.18,2.07,2.18Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.21,175.29c0-.18-.1-.26-.26-.26h-.49v-1h1.12c.52,0,.77.23.77.67v.23c0,.19-.02.35-.02.35h.02c.24-.53.96-1.39,2.28-1.39,1.44,0,2.09.78,2.09,2.33v2.63c0,.18.1.26.26.26h.49v1h-1.15c-.54,0-.77-.23-.77-.77v-2.85c0-.85-.17-1.52-1.14-1.52s-1.68.61-1.92,1.49c-.08.24-.11.52-.11.82v2.84h-1.16v-4.83Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.72,175.29c0-.18-.1-.26-.26-.26h-.49v-1h1.12c.52,0,.77.23.77.67v.23c0,.19-.02.35-.02.35h.02c.24-.53.96-1.39,2.28-1.39,1.44,0,2.09.78,2.09,2.33v2.63c0,.18.1.26.26.26h.49v1h-1.15c-.54,0-.77-.23-.77-.77v-2.85c0-.85-.17-1.52-1.14-1.52s-1.68.61-1.92,1.49c-.08.24-.11.52-.11.82v2.84h-1.16v-4.83Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.69,173.89c1.7,0,2.61,1.27,2.61,2.84,0,.16-.04.48-.04.48h-4.43c.07,1.3,1.01,2.03,2.09,2.03s1.78-.71,1.78-.71l.5.83s-.9.89-2.34.89c-1.92,0-3.23-1.38-3.23-3.18,0-1.93,1.32-3.18,3.05-3.18h.01Zm1.42,2.47c-.04-1.01-.67-1.55-1.43-1.55-.89,0-1.61.54-1.79,1.55h3.22Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.86,175.29c0-.18-.1-.26-.26-.26h-.49v-1h1.12c.53,0,.77.23.77.67v.23c0,.19-.01.35-.01.35h.02c.29-.71,1.13-1.39,2.08-1.39,1.03,0,1.62.47,1.82,1.38h.02c.34-.73,1.18-1.38,2.16-1.38,1.37,0,2,.78,2,2.33v2.63c0,.18.1.26.26.26h.49v1h-1.15c-.54,0-.77-.23-.77-.77v-2.87c0-.85-.17-1.52-1.07-1.52-.84,0-1.49.73-1.7,1.56-.06.25-.1.52-.1.83v2.77h-1.16v-3.63c0-.79-.12-1.52-1.04-1.52s-1.51.74-1.74,1.61c-.06.24-.08.5-.08.78v2.77h-1.16v-4.83Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.56,173.89c1.7,0,2.62,1.27,2.62,2.84,0,.16-.04.48-.04.48h-4.43c.07,1.3,1.01,2.03,2.09,2.03s1.78-.71,1.78-.71l.5.83s-.9.89-2.34.89c-1.92,0-3.23-1.38-3.23-3.18,0-1.93,1.32-3.18,3.05-3.18Zm1.42,2.47c-.04-1.01-.67-1.55-1.43-1.55-.89,0-1.61.54-1.79,1.55h3.22Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m133.73,175.29c0-.18-.1-.26-.26-.26h-.49v-1h1.12c.52,0,.77.23.77.67v.23c0,.19-.02.35-.02.35h.02c.24-.53.96-1.39,2.28-1.39,1.44,0,2.09.78,2.09,2.33v2.63c0,.18.1.26.26.26h.49v1h-1.15c-.54,0-.77-.23-.77-.77v-2.85c0-.85-.17-1.52-1.14-1.52s-1.68.61-1.92,1.49c-.08.24-.11.52-.11.82v2.84h-1.16v-4.83Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m141.29,174.97h-.79v-.94h.82v-1.67h1.14v1.67h1.45v.94h-1.45v2.78c0,1.21.84,1.37,1.28,1.37.17,0,.28-.02.28-.02v1.03s-.16.02-.41.02c-.77,0-2.31-.24-2.31-2.27v-2.91h-.01Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "pie2-label2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m141.1,49.42c0-3.9,3-6.9,7.2-6.9s7.2,3,7.2,6.9c0,2.55-1.5,4.5-1.5,4.5l-6.3,9.9h-2.25l4.95-7.8s-.87.3-2.25.3c-4.05,0-7.05-3-7.05-6.9h0Zm7.2,4.8c3,0,4.95-1.95,4.95-4.8s-1.95-4.8-4.95-4.8-4.95,1.95-4.95,4.8,1.95,4.8,4.95,4.8Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m161.95,62.32l-3.45,5.4-1.35-.75,2.7-5.85s2.1,1.2,2.1,1.2Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.95,42.82v21h-2.25v-16.8h-3.9v-1.35c3.6-.15,4.5-2.85,4.5-2.85,0,0,1.65,0,1.65,0Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175.75,49.42c0-3.9,3-6.9,7.2-6.9s7.2,3,7.2,6.9c0,2.55-1.5,4.5-1.5,4.5l-6.3,9.9h-2.25l4.95-7.8s-.87.3-2.25.3c-4.05,0-7.05-3-7.05-6.9h0Zm7.2,4.8c3,0,4.95-1.95,4.95-4.8s-1.95-4.8-4.95-4.8-4.95,1.95-4.95,4.8,1.95,4.8,4.95,4.8Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m211.3,57.82l-8.4-11.1v17.1h-2.25v-21h1.95l8.7,11.4,8.7-11.4h1.95v21h-2.25v-17.1l-8.4,11.1Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m238.6,54.82v1.95h-6.9c.6,2.25,3.6,5.25,7.2,5.25s5.7-2.7,5.7-2.7l1.5,1.5s-2.58,3.3-7.2,3.3-8.4-3.6-9.6-7.35h-3v-1.95h2.7v-3h-2.7v-1.95h3c1.2-3.75,4.8-7.35,9.6-7.35s7.05,3.3,7.05,3.3l-1.5,1.5s-2.01-2.7-5.55-2.7-6.6,3-7.2,5.25h6.9v1.95h-7.35v3s7.35,0,7.35,0Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m140.69,74.38h-.78v-1.03h3.43c2.58,0,4.28,1.55,4.28,4.22s-1.7,4.25-4.28,4.25h-1.88c-.54,0-.77-.23-.77-.77v-6.67h0Zm1.46,6.4h1.1c1.88,0,3.12-1.13,3.12-3.21s-1.25-3.19-3.12-3.19h-1.37v6.14c0,.17.1.26.26.26h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m151.57,75.6c1.7,0,2.62,1.27,2.62,2.84,0,.16-.04.48-.04.48h-4.43c.07,1.3,1.01,2.03,2.09,2.03s1.78-.71,1.78-.71l.5.83s-.9.89-2.34.89c-1.92,0-3.23-1.38-3.23-3.18,0-1.93,1.32-3.18,3.05-3.18h0Zm1.42,2.47c-.04-1.01-.67-1.55-1.43-1.55-.89,0-1.61.54-1.79,1.55h3.22Zm-1.04-4.73h1.18l-1.14,1.52h-.91l.88-1.52h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m155.74,77.01c0-.18-.1-.26-.26-.26h-.49v-1h1.09c.54,0,.74.23.74.61,0,.18,0,.32,0,.32h.02s.5-1.08,2.02-1.08c1.63,0,2.67,1.3,2.67,3.18s-1.17,3.18-2.76,3.18c-1.34,0-1.86-.97-1.86-.97h-.02s.02.22.02.53v2.7h-1.16v-7.21h0Zm2.84,3.96c.96,0,1.75-.79,1.75-2.17s-.71-2.17-1.71-2.17c-.9,0-1.75.64-1.75,2.18,0,1.08.59,2.16,1.71,2.16Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m165.44,75.6c1.7,0,2.62,1.27,2.62,2.84,0,.16-.04.48-.04.48h-4.43c.07,1.3,1.01,2.03,2.09,2.03s1.78-.71,1.78-.71l.5.83s-.9.89-2.34.89c-1.92,0-3.23-1.38-3.23-3.18,0-1.93,1.32-3.18,3.05-3.18h0Zm1.42,2.47c-.04-1.01-.67-1.55-1.43-1.55-.89,0-1.61.54-1.79,1.55h3.22Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m169.61,77.01c0-.18-.1-.26-.26-.26h-.49v-1h1.12c.52,0,.77.23.77.67v.23c0,.19-.02.35-.02.35h.02c.24-.53.96-1.39,2.28-1.39,1.44,0,2.09.78,2.09,2.33v2.63c0,.18.1.26.26.26h.49v1h-1.15c-.54,0-.77-.23-.77-.77v-2.85c0-.85-.17-1.52-1.14-1.52s-1.68.61-1.92,1.49c-.08.24-.11.52-.11.82v2.84h-1.16v-4.83Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m177.02,80.11s.72.9,1.83.9c.56,0,1.06-.25,1.06-.78,0-1.09-3.31-.97-3.31-2.93,0-1.16,1.02-1.7,2.25-1.7.73,0,1.99.25,1.99,1.18v.58h-1.04v-.3c0-.36-.54-.52-.91-.52-.68,0-1.13.24-1.13.72,0,1.15,3.31.9,3.31,2.93,0,1.08-.96,1.77-2.23,1.77-1.62,0-2.42-1.07-2.42-1.07l.6-.78h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m185.03,75.6c1.7,0,2.61,1.27,2.61,2.84,0,.16-.04.48-.04.48h-4.42c.07,1.3,1.01,2.03,2.09,2.03s1.78-.71,1.78-.71l.5.83s-.9.89-2.34.89c-1.92,0-3.23-1.38-3.23-3.18,0-1.93,1.32-3.18,3.05-3.18h0Zm1.42,2.47c-.04-1.01-.67-1.55-1.43-1.55-.89,0-1.61.54-1.79,1.55h3.22Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189.1,80.11s.72.9,1.83.9c.56,0,1.06-.25,1.06-.78,0-1.09-3.31-.97-3.31-2.93,0-1.16,1.02-1.7,2.25-1.7.73,0,1.99.25,1.99,1.18v.58h-1.04v-.3c0-.36-.54-.52-.91-.52-.68,0-1.13.24-1.13.72,0,1.15,3.31.9,3.31,2.93,0,1.08-.96,1.77-2.23,1.77-1.62,0-2.42-1.07-2.42-1.07l.6-.78h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m142.64,89.6c1.4,0,1.87.94,1.87.94h.02s-.02-.18-.02-.41v-1.52c0-.18-.1-.26-.26-.26h-.49v-1h1.15c.54,0,.77.23.77.77v6.44c0,.18.1.26.26.26h.49v1h-1.12c-.53,0-.74-.24-.74-.65,0-.18,0-.31,0-.31h-.02s-.5,1.1-1.99,1.1c-1.64,0-2.67-1.29-2.67-3.18s1.14-3.18,2.75-3.18h0Zm1.91,3.17c0-1.08-.56-2.16-1.73-2.16-.95,0-1.74.79-1.74,2.17s.71,2.17,1.71,2.17c.9,0,1.75-.64,1.75-2.18h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.79,87.21h1.09l-.78,2.34h-.83l.52-2.34Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m150.53,91.01c0-.18-.1-.26-.26-.26h-.49v-1h1.14c.54,0,.77.23.77.77v4.04c0,.18.1.26.26.26h.49v1h-1.14c-.54,0-.77-.23-.77-.77v-4.04Zm.02-3.66h1.04v1.21h-1.04v-1.21Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m153.77,91.01c0-.18-.1-.26-.26-.26h-.49v-1h1.12c.52,0,.77.23.77.67v.23c0,.19-.02.35-.02.35h.02c.24-.53.96-1.39,2.28-1.39,1.44,0,2.09.78,2.09,2.33v2.63c0,.18.1.26.26.26h.49v1h-1.15c-.54,0-.77-.23-.77-.77v-2.85c0-.85-.17-1.52-1.14-1.52s-1.68.61-1.92,1.49c-.08.24-.11.52-.11.82v2.84h-1.16v-4.83Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.78,90.98c-.07-.18-.18-.24-.37-.24h-.12v-1h.6c.54,0,.74.13.92.61l1.31,3.49c.12.34.22.79.22.79h.02s.1-.46.22-.79l1.3-3.49c.18-.48.4-.61.92-.61h.56v1h-.12c-.2,0-.32.06-.4.24l-1.85,4.83h-1.34l-1.87-4.83h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m169.87,89.6c1.7,0,2.61,1.27,2.61,2.84,0,.16-.04.48-.04.48h-4.42c.07,1.3,1.01,2.03,2.09,2.03s1.78-.71,1.78-.71l.5.83s-.9.89-2.34.89c-1.92,0-3.23-1.38-3.23-3.18,0-1.93,1.32-3.18,3.05-3.18h0Zm1.42,2.47c-.04-1.01-.67-1.55-1.43-1.55-.89,0-1.61.54-1.79,1.55h3.22Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m173.94,94.11s.72.9,1.83.9c.56,0,1.06-.25,1.06-.78,0-1.09-3.31-.97-3.31-2.93,0-1.16,1.02-1.7,2.25-1.7.73,0,1.99.25,1.99,1.18v.58h-1.04v-.3c0-.36-.54-.52-.91-.52-.68,0-1.13.24-1.13.72,0,1.15,3.31.9,3.31,2.93,0,1.08-.96,1.77-2.23,1.77-1.62,0-2.42-1.07-2.42-1.07l.6-.78h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.53,90.68h-.79v-.94h.82v-1.67h1.14v1.67h1.45v.94h-1.45v2.78c0,1.21.84,1.37,1.28,1.37.17,0,.28-.02.28-.02v1.03s-.16.02-.41.02c-.77,0-2.31-.24-2.31-2.27v-2.91h-.01Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.77,91.01c0-.18-.1-.26-.26-.26h-.49v-1h1.14c.54,0,.77.23.77.77v4.04c0,.18.1.26.26.26h.49v1h-1.14c-.54,0-.77-.23-.77-.77v-4.04Zm.02-3.66h1.04v1.21h-1.04v-1.21Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.91,94.11s.72.9,1.83.9c.56,0,1.06-.25,1.06-.78,0-1.09-3.31-.97-3.31-2.93,0-1.16,1.02-1.7,2.25-1.7.73,0,1.99.25,1.99,1.18v.58h-1.04v-.3c0-.36-.54-.52-.91-.52-.68,0-1.13.24-1.13.72,0,1.15,3.31.9,3.31,2.93,0,1.08-.96,1.77-2.23,1.77-1.62,0-2.42-1.07-2.42-1.07l.6-.78h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192.36,94.11s.72.9,1.83.9c.56,0,1.06-.25,1.06-.78,0-1.09-3.31-.97-3.31-2.93,0-1.16,1.02-1.7,2.25-1.7.73,0,1.99.25,1.99,1.18v.58h-1.04v-.3c0-.36-.54-.52-.91-.52-.68,0-1.13.24-1.13.72,0,1.15,3.31.9,3.31,2.93,0,1.08-.96,1.77-2.23,1.77-1.62,0-2.42-1.07-2.42-1.07l.6-.78h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m200.36,89.6c1.7,0,2.62,1.27,2.62,2.84,0,.16-.04.48-.04.48h-4.43c.07,1.3,1.01,2.03,2.09,2.03s1.78-.71,1.78-.71l.5.83s-.9.89-2.34.89c-1.92,0-3.23-1.38-3.23-3.18,0-1.93,1.32-3.18,3.05-3.18h0Zm1.42,2.47c-.04-1.01-.67-1.55-1.43-1.55-.89,0-1.61.54-1.79,1.55h3.22Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m204.53,91.01c0-.18-.1-.26-.26-.26h-.49v-1h1.12c.53,0,.77.23.77.67v.23c0,.19,0,.35,0,.35h.02c.29-.71,1.13-1.39,2.08-1.39,1.03,0,1.62.47,1.82,1.38h.02c.34-.73,1.17-1.38,2.16-1.38,1.37,0,2,.78,2,2.33v2.63c0,.18.1.26.26.26h.49v1h-1.15c-.54,0-.77-.23-.77-.77v-2.87c0-.85-.17-1.52-1.07-1.52-.84,0-1.49.73-1.7,1.56-.06.25-.1.52-.1.83v2.77h-1.16v-3.63c0-.79-.12-1.52-1.04-1.52s-1.51.74-1.74,1.61c-.06.24-.08.5-.08.78v2.77h-1.16v-4.83Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m218.23,89.6c1.7,0,2.61,1.27,2.61,2.84,0,.16-.04.48-.04.48h-4.42c.07,1.3,1.01,2.03,2.09,2.03s1.78-.71,1.78-.71l.5.83s-.9.89-2.34.89c-1.92,0-3.23-1.38-3.23-3.18,0-1.93,1.32-3.18,3.05-3.18h0Zm1.42,2.47c-.04-1.01-.67-1.55-1.43-1.55-.89,0-1.61.54-1.79,1.55h3.22Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.4,91.01c0-.18-.1-.26-.26-.26h-.49v-1h1.12c.52,0,.77.23.77.67v.23c0,.19-.02.35-.02.35h.02c.24-.53.96-1.39,2.28-1.39,1.44,0,2.09.78,2.09,2.33v2.63c0,.18.1.26.26.26h.49v1h-1.15c-.54,0-.77-.23-.77-.77v-2.85c0-.85-.17-1.52-1.14-1.52s-1.68.61-1.92,1.49c-.08.24-.11.52-.11.82v2.84h-1.16v-4.83Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m229.96,90.68h-.79v-.94h.82v-1.67h1.14v1.67h1.45v.94h-1.45v2.78c0,1.21.84,1.37,1.28,1.37.17,0,.28-.02.28-.02v1.03s-.16.02-.41.02c-.77,0-2.32-.24-2.32-2.27v-2.91Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "pie2-label3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m302.5,19.05c0,3.9-3,6.9-7.2,6.9s-7.2-3-7.2-6.9c0-2.55,1.5-4.5,1.5-4.5l6.3-9.9h2.25l-4.95,7.8s.87-.3,2.25-.3c4.05,0,7.05,3,7.05,6.9h0Zm-7.2-4.8c-3,0-4.95,1.95-4.95,4.8s1.95,4.8,4.95,4.8,4.95-1.95,4.95-4.8-1.95-4.8-4.95-4.8Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m308.95,24.15l-3.45,5.4-1.35-.75,2.7-5.85,2.1,1.2Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320.83,25.95c-4.38,0-8.43-4.05-8.43-10.8s4.05-10.8,8.4-10.8,8.4,4.05,8.4,10.8-4.05,10.8-8.37,10.8Zm0-2.1c3.12,0,6.12-3,6.12-8.7s-3-8.7-6.15-8.7-6.15,3-6.15,8.7,3,8.7,6.18,8.7Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m338.35,4.65v21h-2.25V8.85h-3.9v-1.35c3.6-.15,4.5-2.85,4.5-2.85,0,0,1.65,0,1.65,0Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m361,19.65l-8.4-11.1v17.1h-2.25V4.65h1.95l8.7,11.4,8.7-11.4h1.95v21h-2.25V8.55l-8.4,11.1h0Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m388.3,16.65v1.95h-6.9c.6,2.25,3.6,5.25,7.2,5.25s5.7-2.7,5.7-2.7l1.5,1.5s-2.58,3.3-7.2,3.3-8.4-3.6-9.6-7.35h-3v-1.95h2.7v-3h-2.7v-1.95h3c1.2-3.75,4.8-7.35,9.6-7.35s7.05,3.3,7.05,3.3l-1.5,1.5s-2.01-2.7-5.55-2.7-6.6,3-7.2,5.25h6.9v1.95h-7.35v3s7.35,0,7.35,0Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m287.36,36.61c-.07-.22-.19-.26-.4-.26h-.17v-1.03h.67c.6,0,.8.13,1,.7l1.86,5.22c.16.46.32,1.16.32,1.16h.02s.16-.71.32-1.16l1.86-5.22c.2-.56.4-.7,1-.7h.67v1.03h-.17c-.22,0-.32.05-.4.26l-2.66,7.17h-1.27l-2.66-7.17Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m297.51,37.57c1.7,0,2.61,1.27,2.61,2.84,0,.16-.04.48-.04.48h-4.43c.07,1.3,1.01,2.03,2.09,2.03s1.78-.71,1.78-.71l.5.83s-.9.89-2.34.89c-1.92,0-3.23-1.38-3.23-3.18,0-1.93,1.32-3.18,3.05-3.18Zm1.42,2.47c-.04-1.01-.67-1.55-1.43-1.55-.89,0-1.61.54-1.79,1.55h3.21Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301.68,38.97c0-.18-.1-.26-.26-.26h-.49v-1h1.1c.53,0,.78.22.78.71v.38c0,.24-.02.42-.02.42h.02c.29-.89.98-1.58,1.92-1.58.16,0,.31.02.31.02v1.15s-.16-.04-.35-.04c-.74,0-1.43.53-1.7,1.43-.11.35-.14.72-.14,1.09v2.48h-1.16v-4.81Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m306.22,42.08s.72.9,1.83.9c.56,0,1.05-.25,1.05-.78,0-1.09-3.31-.97-3.31-2.93,0-1.16,1.02-1.7,2.25-1.7.73,0,1.99.25,1.99,1.18v.58h-1.04v-.3c0-.36-.54-.52-.91-.52-.68,0-1.13.24-1.13.72,0,1.15,3.31.9,3.31,2.93,0,1.08-.96,1.78-2.23,1.78-1.62,0-2.42-1.07-2.42-1.07l.6-.78Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m314.23,37.57c1.7,0,2.61,1.27,2.61,2.84,0,.16-.04.48-.04.48h-4.43c.07,1.3,1.01,2.03,2.09,2.03s1.78-.71,1.78-.71l.5.83s-.9.89-2.34.89c-1.92,0-3.23-1.38-3.23-3.18,0-1.93,1.32-3.18,3.05-3.18Zm1.42,2.47c-.04-1.01-.67-1.55-1.43-1.55-.89,0-1.61.54-1.79,1.55h3.21Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m318.39,38.97c0-.18-.1-.26-.26-.26h-.49v-1h1.12c.53,0,.77.23.77.67v.23c0,.19-.01.35-.01.35h.02c.29-.71,1.13-1.39,2.07-1.39,1.03,0,1.62.47,1.82,1.38h.02c.33-.73,1.17-1.38,2.16-1.38,1.37,0,2,.78,2,2.33v2.63c0,.18.1.26.26.26h.49v1h-1.15c-.54,0-.77-.23-.77-.77v-2.87c0-.85-.17-1.52-1.07-1.52-.84,0-1.49.73-1.7,1.56-.06.25-.1.52-.1.83v2.77h-1.16v-3.63c0-.79-.12-1.52-1.04-1.52s-1.51.74-1.74,1.61c-.06.24-.08.5-.08.78v2.77h-1.16v-4.81Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m332.09,37.57c1.7,0,2.61,1.27,2.61,2.84,0,.16-.04.48-.04.48h-4.43c.07,1.3,1.01,2.03,2.09,2.03s1.78-.71,1.78-.71l.5.83s-.9.89-2.34.89c-1.92,0-3.23-1.38-3.23-3.18,0-1.93,1.32-3.18,3.05-3.18Zm1.42,2.47c-.04-1.01-.67-1.55-1.43-1.55-.89,0-1.61.54-1.79,1.55h3.21Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m336.26,38.97c0-.18-.1-.26-.26-.26h-.49v-1h1.12c.52,0,.77.23.77.67v.23c0,.19-.02.35-.02.35h.02c.24-.53.96-1.39,2.28-1.39,1.44,0,2.09.78,2.09,2.33v2.63c0,.18.1.26.26.26h.49v1h-1.15c-.54,0-.77-.23-.77-.77v-2.85c0-.85-.17-1.52-1.14-1.52s-1.68.61-1.92,1.49c-.08.24-.11.52-.11.82v2.84h-1.16v-4.81Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m343.82,38.65h-.79v-.94h.82v-1.67h1.14v1.67h1.45v.94h-1.45v2.78c0,1.21.84,1.37,1.28,1.37.17,0,.28-.02.28-.02v1.03s-.16.02-.41.02c-.77,0-2.31-.24-2.31-2.27v-2.91Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m353.39,37.57c1.4,0,1.87.94,1.87.94h.02s-.02-.18-.02-.41v-1.52c0-.18-.1-.26-.26-.26h-.49v-1h1.15c.54,0,.77.23.77.77v6.44c0,.18.1.26.26.26h.49v1h-1.12c-.53,0-.74-.24-.74-.65,0-.18.01-.31.01-.31h-.02s-.5,1.1-1.99,1.1c-1.64,0-2.67-1.3-2.67-3.18s1.14-3.18,2.75-3.18Zm1.91,3.17c0-1.08-.56-2.16-1.73-2.16-.95,0-1.74.79-1.74,2.17s.71,2.17,1.71,2.17c.9,0,1.75-.64,1.75-2.18Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360.94,37.57c1.7,0,2.61,1.27,2.61,2.84,0,.16-.04.48-.04.48h-4.43c.07,1.3,1.01,2.03,2.09,2.03s1.78-.71,1.78-.71l.5.83s-.9.89-2.34.89c-1.92,0-3.23-1.38-3.23-3.18,0-1.93,1.32-3.18,3.05-3.18Zm1.42,2.47c-.04-1.01-.67-1.55-1.43-1.55-.89,0-1.61.54-1.79,1.55h3.21Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m365.01,42.08s.72.9,1.83.9c.56,0,1.05-.25,1.05-.78,0-1.09-3.31-.97-3.31-2.93,0-1.16,1.02-1.7,2.25-1.7.73,0,1.99.25,1.99,1.18v.58h-1.04v-.3c0-.36-.54-.52-.91-.52-.68,0-1.13.24-1.13.72,0,1.15,3.31.9,3.31,2.93,0,1.08-.96,1.78-2.23,1.78-1.62,0-2.42-1.07-2.42-1.07l.6-.78Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m287.67,53.37c0-.18-.1-.26-.26-.26h-.49v-1h1.09c.54,0,.74.23.74.61,0,.18-.01.32-.01.32h.02s.5-1.08,2.01-1.08c1.63,0,2.67,1.29,2.67,3.18s-1.17,3.18-2.76,3.18c-1.34,0-1.86-.97-1.86-.97h-.02s.02.22.02.53v2.7h-1.16v-7.21Zm2.84,3.96c.96,0,1.75-.79,1.75-2.17s-.71-2.17-1.72-2.17c-.9,0-1.75.64-1.75,2.18,0,1.08.59,2.16,1.72,2.16Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m294.92,53.37c0-.18-.1-.26-.26-.26h-.49v-1h1.1c.53,0,.78.22.78.71v.38c0,.24-.02.42-.02.42h.02c.29-.89.98-1.58,1.92-1.58.16,0,.31.02.31.02v1.15s-.16-.04-.35-.04c-.74,0-1.43.53-1.7,1.43-.11.35-.14.72-.14,1.09v2.48h-1.16v-4.81Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301.78,51.97c1.7,0,2.61,1.27,2.61,2.84,0,.16-.04.48-.04.48h-4.43c.07,1.3,1.01,2.03,2.09,2.03s1.78-.71,1.78-.71l.5.83s-.9.89-2.34.89c-1.92,0-3.23-1.38-3.23-3.18,0-1.93,1.32-3.18,3.05-3.18Zm1.42,2.47c-.04-1.01-.67-1.55-1.43-1.55-.89,0-1.61.54-1.79,1.55h3.21Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m305.85,56.48s.72.9,1.83.9c.56,0,1.05-.25,1.05-.78,0-1.09-3.31-.97-3.31-2.93,0-1.16,1.02-1.7,2.25-1.7.73,0,1.99.25,1.99,1.18v.58h-1.04v-.3c0-.36-.54-.52-.91-.52-.68,0-1.13.24-1.13.72,0,1.15,3.31.9,3.31,2.93,0,1.08-.96,1.77-2.23,1.77-1.62,0-2.42-1.07-2.42-1.07l.6-.78Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m311.44,53.05h-.79v-.94h.82v-1.67h1.14v1.67h1.45v.94h-1.45v2.78c0,1.21.84,1.37,1.28,1.37.17,0,.28-.02.28-.02v1.03s-.16.02-.41.02c-.77,0-2.31-.24-2.31-2.27v-2.91Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m318.64,54.41h.26v-.06c0-1.07-.4-1.45-1.34-1.45-.29,0-1,.07-1,.47v.35h-1.09v-.6c0-1,1.51-1.14,2.1-1.14,1.97,0,2.5,1.03,2.5,2.37v2.58c0,.18.1.26.26.26h.49v1h-1.09c-.54,0-.76-.26-.76-.7,0-.2.02-.36.02-.36h-.02s-.48,1.2-1.93,1.2c-1.04,0-2.06-.64-2.06-1.85,0-1.96,2.64-2.07,3.66-2.07Zm-1.34,2.99c.98,0,1.62-1.03,1.62-1.93v-.2h-.3c-.88,0-2.46.05-2.46,1.16,0,.49.37.97,1.14.97Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m322.14,53.05h-.79v-.94h.82v-1.67h1.14v1.67h1.45v.94h-1.45v2.78c0,1.21.84,1.37,1.28,1.37.17,0,.28-.02.28-.02v1.03s-.16.02-.41.02c-.77,0-2.31-.24-2.31-2.27v-2.91Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m326.37,53.37c0-.18-.1-.26-.26-.26h-.49v-1h1.14c.54,0,.77.23.77.77v4.04c0,.18.1.26.26.26h.49v1h-1.14c-.54,0-.77-.23-.77-.77v-4.04Zm.02-3.66h1.04v1.21h-1.04v-1.21Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m332.29,51.97c1.81,0,3.27,1.33,3.27,3.17s-1.46,3.19-3.27,3.19-3.26-1.34-3.26-3.19,1.45-3.17,3.26-3.17Zm0,5.35c1.15,0,2.09-.91,2.09-2.18s-.94-2.16-2.09-2.16-2.08.9-2.08,2.16.94,2.18,2.08,2.18Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m337.02,53.37c0-.18-.1-.26-.26-.26h-.49v-1h1.12c.52,0,.77.23.77.67v.23c0,.19-.02.35-.02.35h.02c.24-.53.96-1.39,2.28-1.39,1.44,0,2.09.78,2.09,2.33v2.63c0,.18.1.26.26.26h.49v1h-1.15c-.54,0-.77-.23-.77-.77v-2.85c0-.85-.17-1.52-1.14-1.52s-1.68.61-1.92,1.49c-.08.24-.11.52-.11.82v2.84h-1.16v-4.81Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344.43,56.48s.72.9,1.83.9c.56,0,1.05-.25,1.05-.78,0-1.09-3.31-.97-3.31-2.93,0-1.16,1.02-1.7,2.25-1.7.73,0,1.99.25,1.99,1.18v.58h-1.04v-.3c0-.36-.54-.52-.91-.52-.68,0-1.13.24-1.13.72,0,1.15,3.31.9,3.31,2.93,0,1.08-.96,1.77-2.23,1.77-1.62,0-2.42-1.07-2.42-1.07l.6-.78Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352.69,54.8l1.97-2.47h1.16l-1.97,2.47,1.97,2.46h-1.16l-1.97-2.46Zm4.38-2.47h1.16l-1.97,2.47,1.97,2.46h-1.16l-1.97-2.46,1.97-2.47Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m366.32,54.41h.26v-.06c0-1.07-.4-1.45-1.34-1.45-.29,0-1,.07-1,.47v.35h-1.09v-.6c0-1,1.51-1.14,2.1-1.14,1.97,0,2.5,1.03,2.5,2.37v2.58c0,.18.1.26.26.26h.49v1h-1.09c-.54,0-.76-.26-.76-.7,0-.2.02-.36.02-.36h-.02s-.48,1.2-1.93,1.2c-1.04,0-2.06-.64-2.06-1.85,0-1.96,2.64-2.07,3.66-2.07Zm-1.34,2.99c.98,0,1.62-1.03,1.62-1.93v-.2h-.3c-.88,0-2.46.05-2.46,1.16,0,.49.37.97,1.14.97Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m372.44,51.97c.73,0,2.18.3,2.18,1.33v.62h-1.06v-.34c0-.43-.68-.62-1.13-.62-1.19,0-2.08.89-2.08,2.17,0,1.38,1.01,2.16,2.13,2.16s1.88-.84,1.88-.84l.5.83s-.86,1.04-2.47,1.04c-1.91,0-3.24-1.36-3.24-3.18s1.31-3.18,3.26-3.18Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m378.83,51.97c.73,0,2.18.3,2.18,1.33v.62h-1.06v-.34c0-.43-.68-.62-1.13-.62-1.19,0-2.08.89-2.08,2.17,0,1.38,1.01,2.16,2.13,2.16s1.88-.84,1.88-.84l.5.83s-.86,1.04-2.47,1.04c-1.91,0-3.24-1.36-3.24-3.18s1.31-3.18,3.26-3.18Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m382.61,53.37c0-.18-.1-.26-.26-.26h-.49v-1h1.14c.54,0,.77.23.77.77v4.04c0,.18.1.26.26.26h.49v1h-1.14c-.54,0-.77-.23-.77-.77v-4.04Zm.02-3.66h1.04v1.21h-1.04v-1.21Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m388.03,51.97c1.4,0,1.87.94,1.87.94h.02s-.02-.18-.02-.41v-1.52c0-.18-.1-.26-.26-.26h-.49v-1h1.15c.54,0,.77.23.77.77v6.44c0,.18.1.26.26.26h.49v1h-1.12c-.53,0-.74-.24-.74-.65,0-.18.01-.31.01-.31h-.02s-.5,1.1-1.99,1.1c-1.64,0-2.67-1.3-2.67-3.18s1.14-3.18,2.75-3.18Zm1.91,3.17c0-1.08-.56-2.16-1.73-2.16-.95,0-1.74.79-1.74,2.17s.71,2.17,1.71,2.17c.9,0,1.75-.64,1.75-2.18Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m395.57,51.97c1.7,0,2.61,1.27,2.61,2.84,0,.16-.04.48-.04.48h-4.43c.07,1.3,1.01,2.03,2.09,2.03s1.78-.71,1.78-.71l.5.83s-.9.89-2.34.89c-1.92,0-3.23-1.38-3.23-3.18,0-1.93,1.32-3.18,3.05-3.18Zm1.42,2.47c-.04-1.01-.67-1.55-1.43-1.55-.89,0-1.61.54-1.79,1.55h3.21Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m399.74,53.37c0-.18-.1-.26-.26-.26h-.49v-1h1.12c.52,0,.77.23.77.67v.23c0,.19-.02.35-.02.35h.02c.24-.53.96-1.39,2.28-1.39,1.44,0,2.09.78,2.09,2.33v2.63c0,.18.1.26.26.26h.49v1h-1.15c-.54,0-.77-.23-.77-.77v-2.85c0-.85-.17-1.52-1.14-1.52s-1.68.61-1.92,1.49c-.08.24-.11.52-.11.82v2.84h-1.16v-4.81Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m407.3,53.05h-.79v-.94h.82v-1.67h1.14v1.67h1.45v.94h-1.45v2.78c0,1.21.84,1.37,1.28,1.37.17,0,.28-.02.28-.02v1.03s-.16.02-.41.02c-.77,0-2.31-.24-2.31-2.27v-2.91Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m411.38,56.48s.72.9,1.83.9c.56,0,1.05-.25,1.05-.78,0-1.09-3.31-.97-3.31-2.93,0-1.16,1.02-1.7,2.25-1.7.73,0,1.99.25,1.99,1.18v.58h-1.04v-.3c0-.36-.54-.52-.91-.52-.68,0-1.13.24-1.13.72,0,1.15,3.31.9,3.31,2.93,0,1.08-.96,1.77-2.23,1.77-1.62,0-2.42-1.07-2.42-1.07l.6-.78Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m289.84,66.37c1.4,0,1.87.94,1.87.94h.02s-.02-.18-.02-.41v-1.52c0-.18-.1-.26-.26-.26h-.49v-1h1.15c.54,0,.77.23.77.77v6.44c0,.18.1.26.26.26h.49v1h-1.12c-.53,0-.74-.24-.74-.65,0-.18.01-.31.01-.31h-.02s-.5,1.1-1.99,1.1c-1.64,0-2.67-1.3-2.67-3.18s1.14-3.18,2.75-3.18Zm1.91,3.17c0-1.08-.56-2.16-1.73-2.16-.95,0-1.74.79-1.74,2.17s.71,2.17,1.71,2.17c.9,0,1.75-.64,1.75-2.18Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m294.91,67.77c0-.18-.1-.26-.26-.26h-.49v-1h1.14c.55,0,.78.23.78.74v2.88c0,.84.17,1.51,1.13,1.51,1.25,0,1.98-1.09,1.98-2.29v-2.84h1.16v4.81c0,.18.1.26.26.26h.49v1h-1.11c-.52,0-.77-.24-.77-.67v-.23c0-.19.01-.35.01-.35h-.02c-.25.6-1.03,1.39-2.23,1.39-1.37,0-2.06-.72-2.06-2.33v-2.63Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m305.66,67.45h-.79v-.94h.82v-1.67h1.14v1.67h1.45v.94h-1.45v2.78c0,1.21.84,1.37,1.28,1.37.17,0,.28-.02.28-.02v1.03s-.16.02-.41.02c-.77,0-2.31-.24-2.31-2.27v-2.91Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m309.84,67.77c0-.18-.1-.26-.26-.26h-.49v-1h1.1c.53,0,.78.22.78.71v.38c0,.24-.02.42-.02.42h.02c.29-.89.98-1.58,1.92-1.58.16,0,.31.02.31.02v1.15s-.16-.04-.35-.04c-.74,0-1.43.53-1.7,1.43-.11.35-.14.72-.14,1.09v2.48h-1.16v-4.81Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m317.19,68.81h.26v-.06c0-1.07-.4-1.45-1.34-1.45-.29,0-1,.07-1,.47v.35h-1.09v-.6c0-1,1.51-1.14,2.1-1.14,1.97,0,2.5,1.03,2.5,2.37v2.58c0,.18.1.26.26.26h.49v1h-1.09c-.54,0-.76-.26-.76-.7,0-.2.02-.36.02-.36h-.02s-.48,1.2-1.93,1.2c-1.04,0-2.06-.64-2.06-1.85,0-1.96,2.64-2.07,3.66-2.07Zm-1.34,2.99c.98,0,1.62-1.03,1.62-1.93v-.2h-.3c-.88,0-2.46.05-2.46,1.16,0,.49.37.97,1.14.97Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320.13,67.75c-.07-.18-.18-.24-.37-.24h-.12v-1h.6c.54,0,.74.13.92.61l1.31,3.49c.12.34.22.79.22.79h.02s.1-.46.22-.79l1.29-3.49c.18-.48.4-.61.92-.61h.56v1h-.12c-.2,0-.32.06-.4.24l-1.85,4.83h-1.34l-1.87-4.83Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m329.91,68.81h.26v-.06c0-1.07-.4-1.45-1.34-1.45-.29,0-1,.07-1,.47v.35h-1.09v-.6c0-1,1.51-1.14,2.1-1.14,1.97,0,2.5,1.03,2.5,2.37v2.58c0,.18.1.26.26.26h.49v1h-1.09c-.54,0-.76-.26-.76-.7,0-.2.02-.36.02-.36h-.02s-.48,1.2-1.93,1.2c-1.04,0-2.06-.64-2.06-1.85,0-1.96,2.64-2.07,3.66-2.07Zm-1.34,2.99c.98,0,1.62-1.03,1.62-1.93v-.2h-.3c-.88,0-2.46.05-2.46,1.16,0,.49.37.97,1.14.97Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m333.42,67.77c0-.18-.1-.26-.26-.26h-.49v-1h1.14c.54,0,.77.23.77.77v4.04c0,.18.1.26.26.26h.49v1h-1.14c-.54,0-.77-.23-.77-.77v-4.04Zm.02-3.66h1.04v1.21h-1.04v-1.21Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m336.63,65.38c0-.18-.1-.26-.26-.26h-.49v-1h1.15c.54,0,.77.23.77.77v6.44c0,.18.1.26.26.26h.49v1h-1.15c-.54,0-.77-.23-.77-.77v-6.44Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m345.14,63.66h1.03l-3.05,9.43h-1.03l3.05-9.43Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m350.48,67.77c0-.18-.1-.26-.26-.26h-.49v-1h1.12c.53,0,.77.23.77.67v.23c0,.19-.01.35-.01.35h.02c.29-.71,1.13-1.39,2.07-1.39,1.03,0,1.62.47,1.82,1.38h.02c.33-.73,1.17-1.38,2.16-1.38,1.37,0,2,.78,2,2.33v2.63c0,.18.1.26.26.26h.49v1h-1.15c-.54,0-.77-.23-.77-.77v-2.87c0-.85-.17-1.52-1.07-1.52-.84,0-1.49.73-1.7,1.56-.06.25-.1.52-.1.83v2.77h-1.16v-3.63c0-.79-.12-1.52-1.04-1.52s-1.51.74-1.74,1.61c-.06.24-.08.5-.08.78v2.77h-1.16v-4.81Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m364.81,68.81h.26v-.06c0-1.07-.4-1.45-1.34-1.45-.29,0-1,.07-1,.47v.35h-1.09v-.6c0-1,1.51-1.14,2.1-1.14,1.97,0,2.5,1.03,2.5,2.37v2.58c0,.18.1.26.26.26h.49v1h-1.09c-.54,0-.76-.26-.76-.7,0-.2.02-.36.02-.36h-.02s-.48,1.2-1.93,1.2c-1.04,0-2.06-.64-2.06-1.85,0-1.96,2.64-2.07,3.66-2.07Zm-1.34,2.99c.98,0,1.62-1.03,1.62-1.93v-.2h-.3c-.88,0-2.46.05-2.46,1.16,0,.49.37.97,1.14.97Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m368.23,65.38c0-.18-.1-.26-.26-.26h-.49v-1h1.15c.54,0,.77.23.77.77v6.44c0,.18.1.26.26.26h.49v1h-1.15c-.54,0-.77-.23-.77-.77v-6.44Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m374.55,68.81h.26v-.06c0-1.07-.4-1.45-1.34-1.45-.29,0-1,.07-1,.47v.35h-1.09v-.6c0-1,1.51-1.14,2.1-1.14,1.97,0,2.5,1.03,2.5,2.37v2.58c0,.18.1.26.26.26h.49v1h-1.09c-.54,0-.76-.26-.76-.7,0-.2.02-.36.02-.36h-.02s-.48,1.2-1.93,1.2c-1.04,0-2.06-.64-2.06-1.85,0-1.96,2.64-2.07,3.66-2.07Zm-1.34,2.99c.98,0,1.62-1.03,1.62-1.93v-.2h-.3c-.88,0-2.46.05-2.46,1.16,0,.49.37.97,1.14.97Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m380.17,66.37c1.4,0,1.87.94,1.87.94h.02s-.02-.18-.02-.41v-1.52c0-.18-.1-.26-.26-.26h-.49v-1h1.15c.54,0,.77.23.77.77v6.44c0,.18.1.26.26.26h.49v1h-1.12c-.53,0-.74-.24-.74-.65,0-.18.01-.31.01-.31h-.02s-.5,1.1-1.99,1.1c-1.64,0-2.67-1.3-2.67-3.18s1.14-3.18,2.75-3.18Zm1.91,3.17c0-1.08-.56-2.16-1.73-2.16-.95,0-1.74.79-1.74,2.17s.71,2.17,1.71,2.17c.9,0,1.75-.64,1.75-2.18Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m385.31,67.77c0-.18-.1-.26-.26-.26h-.49v-1h1.14c.54,0,.77.23.77.77v4.04c0,.18.1.26.26.26h.49v1h-1.14c-.54,0-.77-.23-.77-.77v-4.04Zm.02-3.66h1.04v1.21h-1.04v-1.21Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m391.01,66.37c1.7,0,2.61,1.27,2.61,2.84,0,.16-.04.48-.04.48h-4.43c.07,1.3,1.01,2.03,2.09,2.03s1.78-.71,1.78-.71l.5.83s-.9.89-2.34.89c-1.92,0-3.23-1.38-3.23-3.18,0-1.93,1.32-3.18,3.05-3.18Zm1.42,2.47c-.04-1.01-.67-1.55-1.43-1.55-.89,0-1.61.54-1.79,1.55h3.21Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m395.08,70.88s.72.9,1.83.9c.56,0,1.05-.25,1.05-.78,0-1.09-3.31-.97-3.31-2.93,0-1.16,1.02-1.7,2.25-1.7.73,0,1.99.25,1.99,1.18v.58h-1.04v-.3c0-.36-.54-.52-.91-.52-.68,0-1.13.24-1.13.72,0,1.15,3.31.9,3.31,2.93,0,1.08-.96,1.78-2.23,1.78-1.62,0-2.42-1.07-2.42-1.07l.6-.78Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m287.67,82.17c0-.18-.1-.26-.26-.26h-.49v-1h1.09c.54,0,.74.23.74.61,0,.18-.01.32-.01.32h.02s.5-1.08,2.01-1.08c1.63,0,2.67,1.29,2.67,3.18s-1.17,3.18-2.76,3.18c-1.34,0-1.86-.97-1.86-.97h-.02s.02.22.02.53v2.7h-1.16v-7.21Zm2.84,3.96c.96,0,1.75-.79,1.75-2.17s-.71-2.17-1.72-2.17c-.9,0-1.75.64-1.75,2.18,0,1.08.59,2.16,1.72,2.16Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m294.92,82.17c0-.18-.1-.26-.26-.26h-.49v-1h1.1c.53,0,.78.22.78.71v.38c0,.24-.02.42-.02.42h.02c.29-.89.98-1.58,1.92-1.58.16,0,.31.02.31.02v1.15s-.16-.04-.35-.04c-.74,0-1.43.53-1.7,1.43-.11.35-.14.72-.14,1.09v2.48h-1.16v-4.81Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m302,80.77c1.81,0,3.27,1.33,3.27,3.17s-1.46,3.19-3.27,3.19-3.26-1.34-3.26-3.19,1.45-3.17,3.26-3.17Zm0,5.35c1.15,0,2.09-.91,2.09-2.18s-.94-2.16-2.09-2.16-2.07.9-2.07,2.16.94,2.18,2.07,2.18Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m306.73,81.85h-.76v-.94h.76v-.2c0-2,1.52-2.25,2.29-2.25.26,0,.44.04.44.04v1s-.12-.02-.3-.02c-.46,0-1.27.14-1.27,1.27v.18h1.44v.94h-1.44v5.13h-1.16v-5.13Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m312.82,80.77c1.7,0,2.61,1.27,2.61,2.84,0,.16-.04.48-.04.48h-4.43c.07,1.3,1.01,2.03,2.09,2.03s1.78-.71,1.78-.71l.5.83s-.9.89-2.34.89c-1.92,0-3.23-1.38-3.23-3.18,0-1.93,1.32-3.18,3.05-3.18Zm1.42,2.47c-.04-1.01-.67-1.55-1.43-1.55-.89,0-1.61.54-1.79,1.55h3.21Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m316.89,85.28s.72.9,1.83.9c.56,0,1.05-.25,1.05-.78,0-1.09-3.31-.97-3.31-2.93,0-1.16,1.02-1.7,2.25-1.7.73,0,1.99.25,1.99,1.18v.58h-1.04v-.3c0-.36-.54-.52-.91-.52-.68,0-1.13.24-1.13.72,0,1.15,3.31.9,3.31,2.93,0,1.08-.96,1.78-2.23,1.78-1.62,0-2.42-1.07-2.42-1.07l.6-.78Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m322.34,85.28s.72.9,1.83.9c.56,0,1.05-.25,1.05-.78,0-1.09-3.31-.97-3.31-2.93,0-1.16,1.02-1.7,2.25-1.7.73,0,1.99.25,1.99,1.18v.58h-1.04v-.3c0-.36-.54-.52-.91-.52-.68,0-1.13.24-1.13.72,0,1.15,3.31.9,3.31,2.93,0,1.08-.96,1.78-2.23,1.78-1.62,0-2.42-1.07-2.42-1.07l.6-.78Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m327.94,82.17c0-.18-.1-.26-.26-.26h-.49v-1h1.14c.54,0,.77.23.77.77v4.04c0,.18.1.26.26.26h.49v1h-1.14c-.54,0-.77-.23-.77-.77v-4.04Zm.02-3.66h1.04v1.21h-1.04v-1.21Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m333.86,80.77c1.81,0,3.27,1.33,3.27,3.17s-1.46,3.19-3.27,3.19-3.26-1.34-3.26-3.19,1.45-3.17,3.26-3.17Zm0,5.35c1.15,0,2.09-.91,2.09-2.18s-.94-2.16-2.09-2.16-2.08.9-2.08,2.16.94,2.18,2.08,2.18Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m338.59,82.17c0-.18-.1-.26-.26-.26h-.49v-1h1.12c.52,0,.77.23.77.67v.23c0,.19-.02.35-.02.35h.02c.24-.53.96-1.39,2.28-1.39,1.44,0,2.09.78,2.09,2.33v2.63c0,.18.1.26.26.26h.49v1h-1.15c-.54,0-.77-.23-.77-.77v-2.85c0-.85-.17-1.52-1.14-1.52s-1.68.61-1.92,1.49c-.08.24-.11.52-.11.82v2.84h-1.16v-4.81Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m346.1,82.17c0-.18-.1-.26-.26-.26h-.49v-1h1.12c.52,0,.77.23.77.67v.23c0,.19-.02.35-.02.35h.02c.24-.53.96-1.39,2.28-1.39,1.44,0,2.09.78,2.09,2.33v2.63c0,.18.1.26.26.26h.49v1h-1.15c-.54,0-.77-.23-.77-.77v-2.85c0-.85-.17-1.52-1.14-1.52s-1.68.61-1.92,1.49c-.08.24-.11.52-.11.82v2.84h-1.16v-4.81Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356.07,80.77c1.7,0,2.61,1.27,2.61,2.84,0,.16-.04.48-.04.48h-4.43c.07,1.3,1.01,2.03,2.09,2.03s1.78-.71,1.78-.71l.5.83s-.9.89-2.34.89c-1.92,0-3.23-1.38-3.23-3.18,0-1.93,1.32-3.18,3.05-3.18Zm1.42,2.47c-.04-1.01-.67-1.55-1.43-1.55-.89,0-1.61.54-1.79,1.55h3.21Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360.21,79.78c0-.18-.1-.26-.26-.26h-.49v-1h1.15c.54,0,.77.23.77.77v6.44c0,.18.1.26.26.26h.49v1h-1.15c-.54,0-.77-.23-.77-.77v-6.44Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m363.43,79.78c0-.18-.1-.26-.26-.26h-.49v-1h1.15c.54,0,.77.23.77.77v6.44c0,.18.1.26.26.26h.49v1h-1.15c-.54,0-.77-.23-.77-.77v-6.44Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m369.13,80.77c1.7,0,2.61,1.27,2.61,2.84,0,.16-.04.48-.04.48h-4.43c.07,1.3,1.01,2.03,2.09,2.03s1.78-.71,1.78-.71l.5.83s-.9.89-2.34.89c-1.92,0-3.23-1.38-3.23-3.18,0-1.93,1.32-3.18,3.05-3.18Zm1.42,2.47c-.04-1.01-.67-1.55-1.43-1.55-.89,0-1.61.54-1.79,1.55h3.21Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m373.2,85.28s.72.9,1.83.9c.56,0,1.05-.25,1.05-.78,0-1.09-3.31-.97-3.31-2.93,0-1.16,1.02-1.7,2.25-1.7.73,0,1.99.25,1.99,1.18v.58h-1.04v-.3c0-.36-.54-.52-.91-.52-.68,0-1.13.24-1.13.72,0,1.15,3.31.9,3.31,2.93,0,1.08-.96,1.78-2.23,1.78-1.62,0-2.42-1.07-2.42-1.07l.6-.78Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m383.66,83.6l-1.97-2.47h1.16l1.97,2.47-1.97,2.46h-1.16l1.97-2.46Zm2.42,0l-1.97-2.47h1.16l1.97,2.47-1.97,2.46h-1.16l1.97-2.46Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "pie2-label4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m410.8,353.53v21h-2.25v-16.8h-3.9v-1.35c3.6-.15,4.5-2.85,4.5-2.85h1.65Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m430.45,367.93v2.1h-2.7v4.5h-2.25v-4.5h-10.65v-2.55l10.05-13.95h2.85v14.4h2.7Zm-4.95-11.85l-8.55,11.85h8.55v-11.85Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m432.7,374.53c0-8.85,11.25-9.15,11.25-15.15,0-2.4-1.65-4.05-4.5-4.05-3.75,0-4.5,3.6-4.5,3.6l-1.95-.9s1.05-4.8,6.45-4.8c4.05,0,6.75,2.7,6.75,6.15,0,6.45-9.15,7.5-10.95,13.05h10.95v2.1h-13.5Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m452.8,373.03l-3.45,5.4-1.35-.75,2.7-5.85,2.1,1.2Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m456.1,360.13c0-3.9,3-6.9,7.2-6.9s7.2,3,7.2,6.9c0,2.55-1.5,4.5-1.5,4.5l-6.3,9.9h-2.25l4.95-7.8s-.87.3-2.25.3c-4.05,0-7.05-3-7.05-6.9h0Zm7.2,4.8c3,0,4.95-1.95,4.95-4.8s-1.95-4.8-4.95-4.8-4.95,1.95-4.95,4.8,1.95,4.8,4.95,4.8Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m479.5,353.53v21h-2.25v-16.8h-3.9v-1.35c3.6-.15,4.5-2.85,4.5-2.85h1.65Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m502.15,368.53l-8.4-11.1v17.1h-2.25v-21h1.95l8.7,11.4,8.7-11.4h1.95v21h-2.25v-17.1l-8.4,11.1h0Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m529.45,365.53v1.95h-6.9c.6,2.25,3.6,5.25,7.2,5.25s5.7-2.7,5.7-2.7l1.5,1.5s-2.58,3.3-7.2,3.3-8.4-3.6-9.6-7.35h-3v-1.95h2.7v-3h-2.7v-1.95h3c1.2-3.75,4.8-7.35,9.6-7.35s7.05,3.3,7.05,3.3l-1.5,1.5s-2.01-2.7-5.55-2.7-6.6,3-7.2,5.25h6.9v1.95h-7.35v3h7.35Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m404.16,385.36c-.07-.22-.19-.26-.4-.26h-.17v-1.03h.67c.6,0,.8.13,1,.7l1.86,5.22c.16.46.32,1.16.32,1.16h.02s.16-.71.32-1.16l1.86-5.22c.2-.56.4-.7,1-.7h.67v1.03h-.17c-.22,0-.32.05-.4.26l-2.66,7.17h-1.27l-2.66-7.17h.01Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m414.31,386.32c1.7,0,2.62,1.27,2.62,2.84,0,.16-.04.48-.04.48h-4.43c.07,1.3,1.01,2.03,2.09,2.03s1.78-.71,1.78-.71l.5.83s-.9.89-2.34.89c-1.92,0-3.23-1.38-3.23-3.18,0-1.93,1.32-3.18,3.05-3.18h0Zm1.42,2.47c-.04-1.01-.67-1.55-1.43-1.55-.89,0-1.61.54-1.79,1.55h3.22Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m418.48,387.72c0-.18-.1-.26-.26-.26h-.49v-1h1.1c.53,0,.78.22.78.71v.38c0,.24-.02.42-.02.42h.02c.29-.89.98-1.58,1.92-1.58.16,0,.31.02.31.02v1.15s-.16-.04-.35-.04c-.74,0-1.43.53-1.7,1.43-.11.35-.14.72-.14,1.09v2.48h-1.16v-4.81h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m423.02,390.83s.72.9,1.83.9c.56,0,1.06-.25,1.06-.78,0-1.09-3.31-.97-3.31-2.93,0-1.16,1.02-1.7,2.25-1.7.73,0,1.99.25,1.99,1.18v.58h-1.04v-.3c0-.36-.54-.52-.91-.52-.68,0-1.13.24-1.13.72,0,1.15,3.31.9,3.31,2.93,0,1.08-.96,1.77-2.23,1.77-1.62,0-2.42-1.07-2.42-1.07l.6-.78h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m431.03,386.32c1.7,0,2.62,1.27,2.62,2.84,0,.16-.04.48-.04.48h-4.43c.07,1.3,1.01,2.03,2.09,2.03s1.78-.71,1.78-.71l.5.83s-.9.89-2.34.89c-1.92,0-3.23-1.38-3.23-3.18,0-1.93,1.32-3.18,3.05-3.18h0Zm1.42,2.47c-.04-1.01-.67-1.55-1.43-1.55-.89,0-1.61.54-1.79,1.55h3.22Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m435.19,387.72c0-.18-.1-.26-.26-.26h-.49v-1h1.12c.53,0,.77.23.77.67v.23c0,.19-.01.35-.01.35h.02c.29-.71,1.13-1.39,2.08-1.39,1.03,0,1.62.47,1.82,1.38h.02c.34-.73,1.18-1.38,2.16-1.38,1.37,0,2,.78,2,2.33v2.63c0,.18.1.26.26.26h.49v1h-1.15c-.54,0-.77-.23-.77-.77v-2.87c0-.85-.17-1.52-1.07-1.52-.84,0-1.49.73-1.7,1.56-.06.25-.1.52-.1.83v2.77h-1.16v-3.63c0-.79-.12-1.52-1.04-1.52s-1.51.74-1.74,1.61c-.06.24-.08.5-.08.78v2.77h-1.16v-4.83Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m448.89,386.32c1.7,0,2.61,1.27,2.61,2.84,0,.16-.04.48-.04.48h-4.42c.07,1.3,1.01,2.03,2.09,2.03s1.78-.71,1.78-.71l.5.83s-.9.89-2.34.89c-1.92,0-3.23-1.38-3.23-3.18,0-1.93,1.32-3.18,3.05-3.18h0Zm1.42,2.47c-.04-1.01-.67-1.55-1.43-1.55-.89,0-1.61.54-1.79,1.55h3.22Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m453.06,387.72c0-.18-.1-.26-.26-.26h-.49v-1h1.12c.52,0,.77.23.77.67v.23c0,.19-.02.35-.02.35h.02c.24-.53.96-1.39,2.28-1.39,1.44,0,2.09.78,2.09,2.33v2.63c0,.18.1.26.26.26h.49v1h-1.15c-.54,0-.77-.23-.77-.77v-2.85c0-.85-.17-1.52-1.14-1.52s-1.68.61-1.92,1.49c-.08.24-.11.52-.11.82v2.84h-1.16v-4.83Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m460.62,387.4h-.79v-.94h.82v-1.67h1.14v1.67h1.45v.94h-1.45v2.78c0,1.21.84,1.37,1.28,1.37.17,0,.28-.02.28-.02v1.03s-.16.02-.41.02c-.77,0-2.32-.24-2.32-2.27v-2.91Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m470.19,386.32c1.4,0,1.87.94,1.87.94h.02s-.02-.18-.02-.41v-1.52c0-.18-.1-.26-.26-.26h-.49v-1h1.15c.54,0,.77.23.77.77v6.44c0,.18.1.26.26.26h.49v1h-1.12c-.53,0-.74-.24-.74-.65,0-.18.01-.31.01-.31h-.02s-.5,1.1-1.99,1.1c-1.64,0-2.67-1.29-2.67-3.18s1.14-3.18,2.75-3.18h-.01Zm1.91,3.17c0-1.08-.56-2.16-1.73-2.16-.95,0-1.74.79-1.74,2.17s.71,2.17,1.71,2.17c.9,0,1.75-.64,1.75-2.18h.01Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m477.74,386.32c1.7,0,2.61,1.27,2.61,2.84,0,.16-.04.48-.04.48h-4.42c.07,1.3,1.01,2.03,2.09,2.03s1.78-.71,1.78-.71l.5.83s-.9.89-2.34.89c-1.92,0-3.23-1.38-3.23-3.18,0-1.93,1.32-3.18,3.05-3.18h0Zm1.42,2.47c-.04-1.01-.67-1.55-1.43-1.55-.89,0-1.61.54-1.79,1.55h3.22Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m481.81,390.83s.72.9,1.83.9c.56,0,1.06-.25,1.06-.78,0-1.09-3.31-.97-3.31-2.93,0-1.16,1.02-1.7,2.25-1.7.73,0,1.99.25,1.99,1.18v.58h-1.04v-.3c0-.36-.54-.52-.91-.52-.68,0-1.13.24-1.13.72,0,1.15,3.31.9,3.31,2.93,0,1.08-.96,1.77-2.23,1.77-1.62,0-2.42-1.07-2.42-1.07l.6-.78h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m404.47,401.72c0-.18-.1-.26-.26-.26h-.49v-1h1.09c.54,0,.74.23.74.61,0,.18-.01.32-.01.32h.02s.5-1.08,2.02-1.08c1.63,0,2.67,1.3,2.67,3.18s-1.17,3.18-2.76,3.18c-1.34,0-1.86-.97-1.86-.97h-.02s.02.22.02.53v2.7h-1.16v-7.21h0Zm2.84,3.96c.96,0,1.75-.79,1.75-2.17s-.71-2.17-1.71-2.17c-.9,0-1.75.64-1.75,2.18,0,1.08.59,2.16,1.71,2.16h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m411.72,401.72c0-.18-.1-.26-.26-.26h-.49v-1h1.1c.53,0,.78.22.78.71v.38c0,.24-.02.42-.02.42h.02c.29-.89.98-1.58,1.92-1.58.16,0,.31.02.31.02v1.15s-.16-.04-.35-.04c-.74,0-1.43.53-1.7,1.43-.11.35-.14.72-.14,1.09v2.48h-1.16v-4.81h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m418.58,400.32c1.7,0,2.61,1.27,2.61,2.84,0,.16-.04.48-.04.48h-4.42c.07,1.3,1.01,2.03,2.09,2.03s1.78-.71,1.78-.71l.5.83s-.9.89-2.34.89c-1.92,0-3.23-1.38-3.23-3.18,0-1.93,1.32-3.18,3.05-3.18h0Zm1.42,2.47c-.04-1.01-.67-1.55-1.43-1.55-.89,0-1.61.54-1.79,1.55h3.22Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m422.65,404.83s.72.9,1.83.9c.56,0,1.06-.25,1.06-.78,0-1.09-3.31-.97-3.31-2.93,0-1.16,1.02-1.7,2.25-1.7.73,0,1.99.25,1.99,1.18v.58h-1.04v-.3c0-.36-.54-.52-.91-.52-.68,0-1.13.24-1.13.72,0,1.15,3.31.9,3.31,2.93,0,1.08-.96,1.77-2.23,1.77-1.62,0-2.42-1.07-2.42-1.07l.6-.78h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m428.24,401.4h-.79v-.94h.82v-1.67h1.14v1.67h1.45v.94h-1.45v2.78c0,1.21.84,1.37,1.28,1.37.17,0,.28-.02.28-.02v1.03s-.16.02-.41.02c-.77,0-2.31-.24-2.31-2.27v-2.91h-.01Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m435.44,402.75h.26v-.06c0-1.07-.4-1.45-1.34-1.45-.29,0-1,.07-1,.47v.35h-1.09v-.6c0-1,1.51-1.14,2.1-1.14,1.97,0,2.49,1.03,2.49,2.38v2.58c0,.18.1.26.26.26h.49v1h-1.09c-.54,0-.76-.26-.76-.7,0-.2.02-.36.02-.36h-.02s-.48,1.2-1.93,1.2c-1.04,0-2.06-.64-2.06-1.85,0-1.96,2.64-2.08,3.66-2.08h0Zm-1.34,2.99c.98,0,1.62-1.03,1.62-1.93v-.2h-.3c-.88,0-2.46.05-2.46,1.16,0,.49.37.97,1.14.97h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m438.94,401.4h-.79v-.94h.82v-1.67h1.14v1.67h1.45v.94h-1.45v2.78c0,1.21.84,1.37,1.28,1.37.17,0,.28-.02.28-.02v1.03s-.16.02-.41.02c-.77,0-2.32-.24-2.32-2.27v-2.91Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m443.17,401.72c0-.18-.1-.26-.26-.26h-.49v-1h1.14c.54,0,.77.23.77.77v4.04c0,.18.1.26.26.26h.49v1h-1.14c-.54,0-.77-.23-.77-.77v-4.04Zm.02-3.66h1.04v1.21h-1.04v-1.21Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m449.09,400.32c1.81,0,3.27,1.33,3.27,3.17s-1.46,3.19-3.27,3.19-3.26-1.34-3.26-3.19,1.45-3.17,3.26-3.17Zm0,5.35c1.15,0,2.09-.91,2.09-2.18s-.94-2.16-2.09-2.16-2.07.9-2.07,2.16.94,2.18,2.07,2.18Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m453.82,401.72c0-.18-.1-.26-.26-.26h-.49v-1h1.12c.52,0,.77.23.77.67v.23c0,.19-.02.35-.02.35h.02c.24-.53.96-1.39,2.28-1.39,1.44,0,2.09.78,2.09,2.33v2.63c0,.18.1.26.26.26h.49v1h-1.15c-.54,0-.77-.23-.77-.77v-2.85c0-.85-.17-1.52-1.14-1.52s-1.68.61-1.92,1.49c-.08.24-.11.52-.11.82v2.84h-1.16v-4.83Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m461.23,404.83s.72.9,1.83.9c.56,0,1.06-.25,1.06-.78,0-1.09-3.31-.97-3.31-2.93,0-1.16,1.02-1.7,2.25-1.7.73,0,1.99.25,1.99,1.18v.58h-1.04v-.3c0-.36-.54-.52-.91-.52-.68,0-1.13.24-1.13.72,0,1.15,3.31.9,3.31,2.93,0,1.08-.96,1.77-2.23,1.77-1.62,0-2.42-1.07-2.42-1.07l.6-.78h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m469.49,403.15l1.97-2.47h1.16l-1.97,2.47,1.97,2.46h-1.16l-1.97-2.46Zm4.38-2.47h1.16l-1.97,2.47,1.97,2.46h-1.16l-1.97-2.46,1.97-2.47Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m480.04,401.72c0-.18-.1-.26-.26-.26h-.49v-1h1.12c.53,0,.77.23.77.67v.23c0,.19-.01.35-.01.35h.02c.29-.71,1.13-1.39,2.08-1.39,1.03,0,1.62.47,1.82,1.38h.02c.34-.73,1.17-1.38,2.16-1.38,1.37,0,2,.78,2,2.33v2.63c0,.18.1.26.26.26h.49v1h-1.15c-.54,0-.77-.23-.77-.77v-2.87c0-.85-.17-1.52-1.07-1.52-.84,0-1.49.73-1.7,1.56-.06.25-.1.52-.1.83v2.77h-1.16v-3.63c0-.79-.12-1.52-1.04-1.52s-1.51.74-1.74,1.61c-.06.24-.08.5-.08.78v2.77h-1.16v-4.83Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m494.36,402.75h.26v-.06c0-1.07-.4-1.45-1.34-1.45-.29,0-1,.07-1,.47v.35h-1.09v-.6c0-1,1.51-1.14,2.1-1.14,1.97,0,2.49,1.03,2.49,2.38v2.58c0,.18.1.26.26.26h.49v1h-1.09c-.54,0-.76-.26-.76-.7,0-.2.02-.36.02-.36h-.02s-.48,1.2-1.93,1.2c-1.04,0-2.06-.64-2.06-1.85,0-1.96,2.64-2.08,3.66-2.08h0Zm-1.34,2.99c.98,0,1.62-1.03,1.62-1.93v-.2h-.3c-.88,0-2.46.05-2.46,1.16,0,.49.37.97,1.14.97h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m497.78,399.33c0-.18-.1-.26-.26-.26h-.49v-1h1.15c.54,0,.77.23.77.77v6.44c0,.18.1.26.26.26h.49v1h-1.15c-.54,0-.77-.23-.77-.77v-6.44Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m504.11,402.75h.26v-.06c0-1.07-.4-1.45-1.34-1.45-.29,0-1,.07-1,.47v.35h-1.09v-.6c0-1,1.51-1.14,2.1-1.14,1.97,0,2.49,1.03,2.49,2.38v2.58c0,.18.1.26.26.26h.49v1h-1.09c-.54,0-.76-.26-.76-.7,0-.2.02-.36.02-.36h-.02s-.48,1.2-1.93,1.2c-1.04,0-2.06-.64-2.06-1.85,0-1.96,2.64-2.08,3.66-2.08h0Zm-1.34,2.99c.98,0,1.62-1.03,1.62-1.93v-.2h-.3c-.88,0-2.46.05-2.46,1.16,0,.49.37.97,1.14.97h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m509.72,400.32c1.4,0,1.87.94,1.87.94h.02s-.02-.18-.02-.41v-1.52c0-.18-.1-.26-.26-.26h-.49v-1h1.15c.54,0,.77.23.77.77v6.44c0,.18.1.26.26.26h.49v1h-1.12c-.53,0-.74-.24-.74-.65,0-.18.01-.31.01-.31h-.02s-.5,1.1-1.99,1.1c-1.64,0-2.67-1.29-2.67-3.18s1.14-3.18,2.75-3.18h-.01Zm1.91,3.17c0-1.08-.56-2.16-1.73-2.16-.95,0-1.74.79-1.74,2.17s.71,2.17,1.71,2.17c.9,0,1.75-.64,1.75-2.18h.01Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m514.87,401.72c0-.18-.1-.26-.26-.26h-.49v-1h1.14c.54,0,.77.23.77.77v4.04c0,.18.1.26.26.26h.49v1h-1.14c-.54,0-.77-.23-.77-.77v-4.04Zm.02-3.66h1.04v1.21h-1.04v-1.21Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m520.57,400.32c1.7,0,2.61,1.27,2.61,2.84,0,.16-.04.48-.04.48h-4.42c.07,1.3,1.01,2.03,2.09,2.03s1.78-.71,1.78-.71l.5.83s-.9.89-2.34.89c-1.92,0-3.23-1.38-3.23-3.18,0-1.93,1.32-3.18,3.05-3.18h0Zm1.42,2.47c-.04-1.01-.67-1.55-1.43-1.55-.89,0-1.61.54-1.79,1.55h3.22Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m529.65,403.15l-1.97-2.47h1.16l1.97,2.47-1.97,2.46h-1.16l1.97-2.46Zm2.42,0l-1.97-2.47h1.16l1.97,2.47-1.97,2.46h-1.16l1.97-2.46Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB2Charts2);
export default __webpack_public_path__ + "static/media/b2-charts2.385fdf639735d1f85b7c8f6afd3b8847.svg";
export { ForwardRef as ReactComponent };